/* eslint-disable @typescript-eslint/naming-convention */
const categoryMappingCMSV28: Record<string, string> = {
  null: '',
  1: 'HIV/AIDS',
  6: 'Opportunistic Infections',
  17: 'Cancer',
  18: 'Cancer',
  19: 'Cancer',
  20: 'Cancer',
  21: 'Cancer',
  22: 'Cancer',
  23: 'Cancer',
  35: 'Diabetes',
  37: 'Diabetes',
  38: 'Diabetes',
  48: 'Morbid Obesity',
  49: 'Specified Lysosomal Storage Disorders',
  50: 'Amyloidosis, Porphyria, and Other Specified Metabolic Disorders',
  51: 'Addison\'s and Cushing\'s Diseases, Acromegaly, and Other Specified Endocrine Disorders',
  62: 'Liver Disease',
  63: 'Liver Disease',
  64: 'Liver Disease',
  65: 'Liver Disease',
  68: 'Liver Disease',
  77: 'Intestine Transplant Status/Complications',
  79: 'Chronic Pancreatitis',
  80: 'Inflammatory Bowel Disease',
  81: 'Inflammatory Bowel Disease',
  92: 'Bone/Joint/Muscle/Severe Soft Tissue Infections/Necrosis',
  93: 'Rheumatoid Arthritis and Other Specified Inflammatory Rheumatic Disorders',
  94: 'Systemic Lupus Erythematosus and Other Specified Systemic Connective Tissue Disorders',
  107: 'Sickle Cell Disease',
  108: 'Sickle Cell Disease',
  109: 'Acquired Hemolytic, Aplastic, and Sideroblastic Anemias',
  111: 'Hemorrhagic Disorders',
  112: 'Hemorrhagic Disorders',
  114: 'Immunodeficiencies',
  115: 'Immunodeficiencies',
  125: 'Dementia',
  126: 'Dementia',
  127: 'Dementia',
  135: 'Substance Use Disorder',
  136: 'Substance Use Disorder',
  137: 'Substance Use Disorder',
  138: 'Substance Use Disorder',
  139: 'Substance Use Disorder',
  151: 'Behavioral Health',
  152: 'Behavioral Health',
  153: 'Behavioral Health',
  154: 'Behavioral Health',
  155: 'Behavioral Health',
  180: 'Paralyses',
  181: 'Paralyses',
  182: 'Paralyses',
  190: 'Amyotrophic Lateral Sclerosis and Other Motor Neuron Disease, Spinal',
  191: 'Paralyses',
  192: 'Paralyses',
  193: 'Chronic Inflammatory Demyelinating Polyneuritis and Multifocal Motor Neuropathy',
  195: 'Myasthenia Gravis with (Acute) Exacerbation',
  196: 'Myasthenia Gravis without (Acute) Exacerbation and Other Myoneural Disorders',
  197: 'Muscular Dystrophy',
  198: 'Multiple Sclerosis',
  199: 'Parkinson and Other Degenerative Disease of Basal Ganglia',
  200: 'Friedreich and Other Hereditary Ataxias; Huntington Disease',
  201: 'Seizure Disorders and Convulsions',
  211: 'Respirator Dependence/Tracheostomy Status/Complications',
  213: 'Cardio-Respiratory Failure and Shock',
  221: 'Heart Disease',
  222: 'Heart Disease',
  223: 'Heart Disease',
  224: 'Heart Disease',
  226: 'Heart Disease',
  227: 'Heart Disease',
  238: 'Specified Heart Arrhythmias',
  253: 'Paralyses',
  254: 'Paralyses',
  263: 'Vascular Disease',
  264: 'Vascular Disease',
  267: 'Deep Vein Thrombosis and Pulmonary Embolism',
  276: 'Lung Disease',
  277: 'Lung Disease',
  278: 'Lung Disease',
  279: 'Lung Disease',
  280: 'Lung Disease',
  298: 'Severe Diabetic Eye Disease, Retinal Vein Occlusion, and Vitreous Hemorrhage',
  300: 'Exudative Macular Degeneration',
  326: 'Chronic Kidney Disease',
  327: 'Chronic Kidney Disease',
  328: 'Chronic Kidney Disease',
  329: 'Chronic Kidney Disease',
  379: 'Ulcer of Skin',
  380: 'Ulcer of Skin',
  381: 'Ulcer of Skin',
  382: 'Ulcer of Skin',
  383: 'Ulcer of Skin',
  387: 'Pemphigus, Pemphigoid, and Other Specified Autoimmune Skin Disorders',
  409: 'Amputation Status, Lower Limb/Amputation Complications',
  454: 'Stem Cell, Including Bone Marrow, Transplant Status/Complications',
  463: 'Artificial Openings for Feeding or Elimination'
}

export default categoryMappingCMSV28
